export const SALES_CONDITIONS_LIST_REQUEST = 'SALES_CONDITIONS_LIST_REQUEST';
export const SALES_CONDITIONS_LIST_SUCCESS = 'SALES_CONDITIONS_LIST_SUCCESS';
export const SALES_CONDITIONS_LIST_FAILURE = 'SALES_CONDITIONS_LIST_FAILURE';

export function success(payload) {
  return dispatch => dispatch({ type: SALES_CONDITIONS_LIST_SUCCESS, payload });
}

export function failure(payload) {
  return dispatch => dispatch({ type: SALES_CONDITIONS_LIST_FAILURE, payload });
}

export default function list() {
  return dispatch => dispatch({ type: SALES_CONDITIONS_LIST_REQUEST });
}
